/**
 * Styled Components - Created by cazarez on 22/05/18.
 */
import styled from 'styled-components'

interface DivProps {
  order?: number
}

export const Container = styled.div`
  order: ${({ order }: DivProps) => order || 'unset'};
  padding: 30px 0 70px;
  background-color: #fff;

  @media (min-width: 320px) and (max-width: 767px) {
    padding: 22px 0 37px;
  }

  @media (min-width: 320px) and (max-width: 991px) {
    border-top: 1px solid #dcdcdc;
  }
`

export const Title = styled.div`
  height: 27px;
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  text-align: center;
  margin-bottom: 23px;
`

export const FeaturedContent = styled.ul`
  overflow-x: scroll;
  display: -webkit-box;
  list-style: none;
  padding: 0;
`
export const ThumbnailListItem = styled.li`
  @media (min-width: 320px) and (max-width: 480px) {
    width: 50%;
    margin: 0 5px;
  }
`

export const ItemContainer = styled.div`
  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0 5px;
  }
`

export const CarouselContent = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  overflow-x: scroll;
  padding-inline: var(--spacing-16);
  [data-appearance='catalog'] {
    width: 324px;
    padding-inline: 9px;
  }
  @media (max-width: 1024px) {
    #CatalogDesktopFooterRow {
      flex-wrap: wrap;
    }
    [data-appearance='catalog'] {
      width: 250px;
    }
  }
`

export const Loading = styled.div`
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0 5px;
    height: 30vh;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/FeaturedProducts/styledComponents.tsx